//
import CommuneModel from '@/models/General/GCommune'
import StateModel from '@/models/General/GState'
import SalePaymentTypeModel from '@/models/POS/PosSalePaymentType'
import CustomerModel from '@/models/Sale/SlCustomer'
import UserModel from '@/models/General/GUser'

/**
 * Dispatch Request Filters
 * 
 * @type       {Array}
 */
export default [
  {
    name: 'creation_date_day_min',
    type: 'date-field',
    props: {
      label: 'Desde fecha',
    },
  },
  {
    name: 'creation_date_hour_min',
    type: 'text-field',
    props: {
      label: 'Desde hora',
      step: 1,
      type: 'time',
      value: '00:00:00'
    },
  },
  {
    name: 'creation_date_day_max',
    type: 'date-field',
    props: {
      label: 'Hasta fecha',
    },
  },
  {
    name: 'creation_date_hour_max',
    type: 'text-field',
    props: {
      label: 'Hasta hora',
      step: 1,
      type: 'time',
      value: '00:00:00'
    },
  },
  {
    name: 'sl_customer_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'business_name',
      itemValue: 'id',
      label: 'Cliente',
      model: CustomerModel,
      noDataText: 'Sin clientes',
      noObject: true,
    },
    trigger: ctx => {
      ctx.getField('sl_customer_branch_offices_id').props.items = ctx.getInput('sl_customer_id').getSelected().branch_offices
      ctx.$forceUpdate()
    }
  },
  {
    name: 'sl_customer_branch_offices_id',
    type: 'select',
    props: {
      itemText: 'address',
      itemValue: 'id',
      label: 'Sucursal del cliente',
      noDataText: 'Sin sucursales',
    },
  },
  {
    name: 'g_seller_user_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'hr_employee_name_case',
      itemValue: 'id',
      label: 'Vendedor',
      model: UserModel,
      noDataText: 'Sin vendedores',
      noObject: true,
      paramFilter: {
        seller_user: true,
      },
    },
  },
  {
    name: 'g_commune_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Comuna',
      model: CommuneModel,
      noDataText: 'Sin comunas',
      noObject: true,
      paramSearch: 'name',
    },
  },
  {
    name: 'zone',
    type: 'text-field',
    props: {
      label: 'Zona',
    },
  },
  {
    name: 'g_state_id',
    type: 'autocomplete-model',
    props: {
      hideDetails: true,
      itemText: 'state',
      itemValue: 'id',
      label: 'Estado',
      model: StateModel,
      noAsyncSearch: true,
      noObject: true,
      paramFilter: {
        g_state_type_id: 10,
      },
      paramSearch: 'state',
    },
  },
]
